/* eslint-disable @typescript-eslint/no-unused-vars */
import type { Maybe } from '@backmarket/utils/types/Maybe'
import { z } from 'zod/mini'

import { createBlockSchema } from '../schemas/create-block-schema'
import type { Equal, ExpectTrue } from '../types/validation'

import type { _ApiBlock } from './block'
import { type CTALink, CTALinkSchema } from './cta-link'
import { type Image, ImageSchema } from './image'
import { RecommendationsApiPropsSchema } from './recommendations'
import { RefinedProductsApiPropsSchema } from './refined-products'

/* TypeScript */
type EnhancedCarouselItem = {
  id: string
  thumbnail: Image
  thumbnailName?: Maybe<string>
  recommendation: _ApiBlock<'Recommendations'> | _ApiBlock<'RefinedProducts'>
}

export type EnhancedCarouselApiProps = {
  technicalName?: Maybe<string>
  title?: Maybe<string>
  subtitle?: Maybe<string>
  image?: Maybe<Image>
  carousels: Array<EnhancedCarouselItem>
  cta?: Maybe<CTALink>
}

/* Schemas */
const EnhancedCarouselItemSchema = z.object({
  id: z.string(),
  thumbnail: ImageSchema,
  thumbnailName: z.nullish(z.string()),
  recommendation: z.union([
    createBlockSchema('Recommendations', RecommendationsApiPropsSchema),
    createBlockSchema('RefinedProducts', RefinedProductsApiPropsSchema),
  ]),
})

export const EnhancedCarouselApiPropsSchema = z.object({
  technicalName: z.nullish(z.string()),
  title: z.nullish(z.string()),
  subtitle: z.nullish(z.string()),
  image: z.nullish(ImageSchema),
  carousels: z.array(EnhancedCarouselItemSchema),
  cta: z.nullish(CTALinkSchema),
})

/* Schemas validation */
type TestEnhancedCarouselProps = ExpectTrue<
  Equal<
    EnhancedCarouselApiProps,
    z.infer<typeof EnhancedCarouselApiPropsSchema>
  >
>
